"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = require("../utils");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Paragraph = props => {
  const paragraphCss = (0, _utils.createCssClassByProps)(props);
  let {
    text
  } = props;
  text = {
    __html: text
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
    className: paragraphCss,
    dangerouslySetInnerHTML: text
  });
};

var _default = Paragraph;
exports.default = _default;

//# sourceMappingURL=index.js.map